import { Box, Stack } from '@mui/material';

export function LandingLayout({ children }: { children: React.ReactNode }) {
  return (
    <Box
      sx={(theme) => ({
        position: 'relative',
        width: '100%',
        minHeight: '100vh',
        bgcolor: theme.vars.palette.grey['200'],
      })}
    >
      <Box
        sx={{
          position: 'fixed',
          top: '-160%',
          left: '50%',
          transform: 'translateX(-50%)',
          height: '200vh',
          width: '300vh',
          background: 'linear-gradient(180deg, #4B7BE5 0%, #3E6CD1 100%)',
          borderRadius: '100%',
          zIndex: 0,
        }}
      />

      <Stack
        direction="column"
        alignItems="center"
        justifyContent="space-between"
        sx={(theme) => ({
          minHeight: '100vh',
          p: 3,
          position: 'relative',
          zIndex: 1,
        })}
      >
        {children}
        <Box sx={{ flex: 0.5 }} />
      </Stack>
    </Box>
  );
}
